import { useTranslation } from 'react-i18next';
import { useContext } from '@/components/slider-type/context';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/slider-type/components/subline/subline-v1.css';
import '@/components/slider-type/components/subline/subline-v2.css';

export default function Subline() {
  const { slide } = useContext();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const { t } = useTranslation();

  if (!slide.subline) return null;

  return (
    <div
      data-css-version={cssVersion}
      className='slider-type-subline'
      dangerouslySetInnerHTML={{ __html: t(slide.subline) }}
    />
  );
}
